<template>
  <div>
    <index-nav/>
    <router-view/>
    <index-footer/>
  </div>
</template>

<script>
import IndexNav from "@/views/layout/IndexNav.vue";
import IndexFooter from "@/views/layout/IndexFooter.vue";

export default {
  name: 'IndexLayout',
  components: {IndexFooter, IndexNav},
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>

</style>
